export default __webpack_public_path__ + "static/media/bgWomanWork.4f94cb5a.jpg";